import gql from 'graphql-tag';
import {
    disclosureFragment,
    etfDisclosureFragment
} from '../../graphql/queries/selective-disclosure.query';

// @todo reuse in compare
export const TOP_TEN_HOLDINGS = gql`
    query TopTenHoldings($ticker: String!) {
        mutualFund(ticker: $ticker) {
            name: shortName
            shortName
            ticker
            inceptionDate
            broadAssetClass
            selectiveDisclosures {
                quarterly {
                    ...Disclosure
                }
                monthly {
                    ...Disclosure
                }
            }
        }
    }
    ${disclosureFragment}
`;

export const MOCK_ETF_TOP_TEN_HOLDINGS = {
    exchangeTradedFund: {
        name: 'T. Rowe Price Blue Chip Growth ETF',
        ticker: 'TCHP',
        inceptionDate: '2020-08-04T04:00:00Z',
        selectiveDisclosures: {
            quarterly: {
                asOfDate: '2021-12-31T00:00:00Z',
                individualHoldings: [
                    {
                        rank: 1,
                        name: 'Microsoft',
                        sectorName: 'Information Technology',
                        industryName: 'Software',
                        countryName: 'United States',
                        marketValue: 30318239.04,
                        percentTotalNetAssets: 11.151379,
                        holdingCouponRate: 0,
                        holdingMaturityDate: null,
                        previousQuarterChange: 0,
                        __typename: 'ETFIndividualHolding'
                    },
                    {
                        rank: 2,
                        name: 'Alphabet',
                        sectorName: 'Communication Services',
                        industryName: 'Interactive Media & Services',
                        countryName: 'United States',
                        marketValue: 28052215.02,
                        percentTotalNetAssets: 10.317911,
                        holdingCouponRate: 0,
                        holdingMaturityDate: null,
                        previousQuarterChange: 0,
                        __typename: 'ETFIndividualHolding'
                    },
                    {
                        rank: 3,
                        name: 'Amazon.com',
                        sectorName: 'Consumer Discretionary',
                        industryName: 'Internet & Direct Marketing Retail',
                        countryName: 'United States',
                        marketValue: 26738072.46,
                        percentTotalNetAssets: 9.834555,
                        holdingCouponRate: 0,
                        holdingMaturityDate: null,
                        previousQuarterChange: 0,
                        __typename: 'ETFIndividualHolding'
                    },
                    {
                        rank: 4,
                        name: 'Apple',
                        sectorName: 'Information Technology',
                        industryName:
                            'Technology Hardware, Storage & Peripherals',
                        countryName: 'United States',
                        marketValue: 21119998.23,
                        percentTotalNetAssets: 7.768166,
                        holdingCouponRate: 0,
                        holdingMaturityDate: null,
                        previousQuarterChange: 0,
                        __typename: 'ETFIndividualHolding'
                    },
                    {
                        rank: 5,
                        name: 'Meta Platforms',
                        sectorName: 'Communication Services',
                        industryName: 'Interactive Media & Services',
                        countryName: 'United States',
                        marketValue: 18211670.75,
                        percentTotalNetAssets: 6.698451,
                        holdingCouponRate: 0,
                        holdingMaturityDate: null,
                        previousQuarterChange: 0,
                        __typename: 'ETFIndividualHolding'
                    },
                    {
                        rank: 6,
                        name: 'NVIDIA',
                        sectorName: 'Information Technology',
                        industryName:
                            'Semiconductors & Semiconductor Equipment',
                        countryName: 'United States',
                        marketValue: 8661539.5,
                        percentTotalNetAssets: 3.185809,
                        holdingCouponRate: 0,
                        holdingMaturityDate: null,
                        previousQuarterChange: 0,
                        __typename: 'ETFIndividualHolding'
                    },
                    {
                        rank: 7,
                        name: 'Tesla',
                        sectorName: 'Consumer Discretionary',
                        industryName: 'Automobiles',
                        countryName: 'United States',
                        marketValue: 8357016.24,
                        percentTotalNetAssets: 3.073802,
                        holdingCouponRate: 0,
                        holdingMaturityDate: null,
                        previousQuarterChange: 0,
                        __typename: 'ETFIndividualHolding'
                    },
                    {
                        rank: 8,
                        name: 'Visa',
                        sectorName: 'Information Technology',
                        industryName: 'IT Services',
                        countryName: 'United States',
                        marketValue: 6372140.84,
                        percentTotalNetAssets: 2.343743,
                        holdingCouponRate: 0,
                        holdingMaturityDate: null,
                        previousQuarterChange: 0,
                        __typename: 'ETFIndividualHolding'
                    },
                    {
                        rank: 9,
                        name: 'ServiceNow',
                        sectorName: 'Information Technology',
                        industryName: 'Software',
                        countryName: 'United States',
                        marketValue: 6254174.85,
                        percentTotalNetAssets: 2.300354,
                        holdingCouponRate: 0,
                        holdingMaturityDate: null,
                        previousQuarterChange: 0,
                        __typename: 'ETFIndividualHolding'
                    },
                    {
                        rank: 10,
                        name: 'Intuit',
                        sectorName: 'Information Technology',
                        industryName: 'Software',
                        countryName: 'United States',
                        marketValue: 5607591.96,
                        percentTotalNetAssets: 2.062533,
                        holdingCouponRate: 0,
                        holdingMaturityDate: null,
                        previousQuarterChange: 0,
                        __typename: 'ETFIndividualHolding'
                    }
                ],
                totalHoldings: 92,
                top10Percentage: 58.736703000000006,
                __typename: 'TopTenHolding'
            },
            monthly: [
                {
                    asOfDate: '2022-01-31T00:00:00Z',
                    individualHoldings: [
                        {
                            rank: 1,
                            name: 'Microsoft',
                            sectorName: 'Information Technology',
                            industryName: 'Software',
                            countryName: 'United States',
                            marketValue: 28856456.16,
                            percentTotalNetAssets: 11.539788,
                            holdingCouponRate: 0,
                            holdingMaturityDate: null,
                            previousQuarterChange: 0,
                            __typename: 'ETFIndividualHolding'
                        },
                        {
                            rank: 2,
                            name: 'Alphabet',
                            sectorName: 'Communication Services',
                            industryName: 'Interactive Media & Services',
                            countryName: 'United States',
                            marketValue: 26971727.44,
                            percentTotalNetAssets: 10.786079,
                            holdingCouponRate: 0,
                            holdingMaturityDate: null,
                            previousQuarterChange: 0,
                            __typename: 'ETFIndividualHolding'
                        },
                        {
                            rank: 3,
                            name: 'Amazon.com',
                            sectorName: 'Consumer Discretionary',
                            industryName: 'Internet & Direct Marketing Retail',
                            countryName: 'United States',
                            marketValue: 24688601.91,
                            percentTotalNetAssets: 9.87305,
                            holdingCouponRate: 0,
                            holdingMaturityDate: null,
                            previousQuarterChange: 0,
                            __typename: 'ETFIndividualHolding'
                        },
                        {
                            rank: 4,
                            name: 'Apple',
                            sectorName: 'Information Technology',
                            industryName:
                                'Technology Hardware, Storage & Peripherals',
                            countryName: 'United States',
                            marketValue: 21493570.5,
                            percentTotalNetAssets: 8.595347,
                            holdingCouponRate: 0,
                            holdingMaturityDate: null,
                            previousQuarterChange: 0,
                            __typename: 'ETFIndividualHolding'
                        },
                        {
                            rank: 5,
                            name: 'Meta Platforms',
                            sectorName: 'Communication Services',
                            industryName: 'Interactive Media & Services',
                            countryName: 'United States',
                            marketValue: 17358676.38,
                            percentTotalNetAssets: 6.94179,
                            holdingCouponRate: 0,
                            holdingMaturityDate: null,
                            previousQuarterChange: 0,
                            __typename: 'ETFIndividualHolding'
                        },
                        {
                            rank: 6,
                            name: 'Tesla',
                            sectorName: 'Consumer Discretionary',
                            industryName: 'Automobiles',
                            countryName: 'United States',
                            marketValue: 7734497.04,
                            percentTotalNetAssets: 3.09305,
                            holdingCouponRate: 0,
                            holdingMaturityDate: null,
                            previousQuarterChange: 0,
                            __typename: 'ETFIndividualHolding'
                        },
                        {
                            rank: 7,
                            name: 'NVIDIA',
                            sectorName: 'Information Technology',
                            industryName:
                                'Semiconductors & Semiconductor Equipment',
                            countryName: 'United States',
                            marketValue: 7683951.66,
                            percentTotalNetAssets: 3.072837,
                            holdingCouponRate: 0,
                            holdingMaturityDate: null,
                            previousQuarterChange: 0,
                            __typename: 'ETFIndividualHolding'
                        },
                        {
                            rank: 8,
                            name: 'Visa',
                            sectorName: 'Information Technology',
                            industryName: 'IT Services',
                            countryName: 'United States',
                            marketValue: 6872853.96,
                            percentTotalNetAssets: 2.748476,
                            holdingCouponRate: 0,
                            holdingMaturityDate: null,
                            previousQuarterChange: 0,
                            __typename: 'ETFIndividualHolding'
                        },
                        {
                            rank: 9,
                            name: 'ServiceNow',
                            sectorName: 'Information Technology',
                            industryName: 'Software',
                            countryName: 'United States',
                            marketValue: 5805665.58,
                            percentTotalNetAssets: 2.321704,
                            holdingCouponRate: 0,
                            holdingMaturityDate: null,
                            previousQuarterChange: 0,
                            __typename: 'ETFIndividualHolding'
                        },
                        {
                            rank: 10,
                            name: 'MasterCard',
                            sectorName: 'Information Technology',
                            industryName: 'IT Services',
                            countryName: 'United States',
                            marketValue: 5491618.94,
                            percentTotalNetAssets: 2.196116,
                            holdingCouponRate: 0,
                            holdingMaturityDate: null,
                            previousQuarterChange: 0,
                            __typename: 'ETFIndividualHolding'
                        }
                    ],
                    totalHoldings: 0,
                    top10Percentage: 61.16823699999999,
                    __typename: 'TopTenHolding'
                }
            ],
            __typename: 'ETFSelectiveDisclosure'
        },
        __typename: 'ExchangeTradedFund'
    }
};

// @todo reuse in compare
export const ETF_TOP_TEN_HOLDINGS = gql`
    query ETFTopTenHoldings($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            name
            ticker
            inceptionDate
            selectiveDisclosures {
                quarterly {
                    ...ETFDisclosure
                }
                monthly {
                    ...ETFDisclosure
                }
            }
        }
    }
    ${etfDisclosureFragment}
`;
